<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">展会管理</el-breadcrumb-item>
      <el-breadcrumb-item>场馆配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->

        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"  style="width: 100%;">

          <template style="width: 100%" >
            <el-table-column prop="name" label="场馆名称" align="center"></el-table-column>
            <el-table-column prop="area" label="面积" align="center"></el-table-column>

            <el-table-column prop="image" label="场馆图" align="center">
              <template slot-scope="scope">
                <el-popover placement="top-start" trigger="hover">
                  <!--trigger属性值：hover、click、focus 和 manual-->
                  <a :href="scope.row.image" target="_blank" title="查看最大化图片"><img :src="scope.row.image" style="width: 300px;height: 300px" /></a>
                  <img slot="reference" :src="scope.row.image" style="width: 50px;height: 50px; cursor:pointer" />
                </el-popover>
              </template>
            </el-table-column>


            <el-table-column  label="操作" align="center" fixed="right" width="200px">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              </template>
            </el-table-column>

          </template>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")' :close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="展会名称" prop="name">
              <el-input size="small" v-model="editForm.name"  auto-complete="off" placeholder="请输入名称"></el-input>
            </el-form-item>

            <el-form-item label="面积" prop="area">
              <el-input size="small" v-model="editForm.area"  auto-complete="off" placeholder="请输入面积"></el-input>
            </el-form-item>

            <el-form-item label="场馆图片" prop="image">
              <el-upload
                class="avatar-uploader"
                :action="this.host+'/fileUpload/ossBatch'"
                :show-file-list="false"
                :on-success="handleAvatarSuccessOne"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.image" :src="editForm.image" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">图片大小不超过2MB。建议宽度1125*1125。</div>
              </el-upload>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title"  :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import {qryStadiumList,upStadium} from '../../api/courseApi'
  import Pagination from '../../components/Pagination'
  import {timestampToTime,parseTime} from "../../utils/util";
export default {
  name: "medalList",
  data() {
    return {
        isDisabled: false,
        loading: false, //是显示加载
        title:'添加',
        editFormVisible:false,
        formInline:{
          exhibitionName:'',
          status:'',
          page:1,
          pageSize:10
        },
        editForm:{
          id:'',
          name:'',
          image:'',
          area:[],
        },
        // rules表单验证
        rules: {
          name: [
            { required: true, message: '名称不能为空', trigger: 'blur' }
          ],
          area: [
            { required: true, message: '面积不能为空', trigger: 'blur' }
          ],
          image: [
            { required: true, message: '必填项不能为空', trigger: 'blur' }
          ],
        },
        listData:[],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryStadiumList(this.formInline).then(res => {
        this.listData = res.data;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false;
      })

    },

    resetFrom(){
      this.formInline.exhibitionName = '';
      this.formInline.status = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    closeDialog(){
      this.$refs['editForm'].resetFields();
      this.baseForm =[]
      this.editFormVisible = false;
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.area=row.area
        this.editForm.image=row.image

      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.area=''
        this.editForm.image=''
      }
    },


    handleAvatarSuccessOne(res) {
      this.editForm.image = res.data;
    },

    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },


    // 编辑、添加提交方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upStadium(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.baseForm = [];

                this.editForm.banner=''
                this.bnImages = []
                this.bnImageUrlList = []
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },


  },
  //分页组件
  components: {
    Pagination
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .redItem.el-form-item__label{
    color: #00ff80;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/platform/stadium.vue